export const CONTACT_US_API_HEADER_KEY =
  "d5acf3f133254c928bb1bc9aa56b8f0f:12504756c2a22697c48b46e6a44fe39585c7561ade6125f04f010843cf9174b6641b4568bc33c02d7ea8f71150e46fc9f0018e376ee0bba10be637e303a0ffc742349411ffbabe885e2c2b29f8eaaf7eb458d4a9633143be431f053dcf2b4cbd";
export const CONTACT_US_API_URL = "https://gateway-stg.airapplecart.co.uk";
